document.addEventListener('DOMContentLoaded', function () {
  const container = document.querySelector('.select-multiple');
  if (!container) return;
  const originalSelect = container.querySelector('select[multiple]');
  if (!originalSelect) return;
  const selectionArea = container.querySelector('.select-multiple__selection-area');
  const placeholder = container.querySelector('.select-multiple__placeholder');
  const selectedTags = container.querySelector('.select-multiple__selected-tags');
  const dropdown = container.querySelector('.select-multiple__dropdown');
  function initOptions() {
    dropdown.innerHTML = '';
    selectedTags.innerHTML = '';

    // Loop through all options of the original select
    Array.from(originalSelect.options).forEach(option => {
      const item = document.createElement('li');
      item.dataset.value = option.value;
      item.dataset.index = option.index;
      item.textContent = option.textContent;
      item.className = option.selected ? 'selected' : '';
      dropdown.appendChild(item);

      // Add a tag for already selected options
      if (option.selected) {
        addTag(option.index, option.textContent);
      }
    });
    updatePlaceholder();
    updateHiddenInputs();
  }
  function addTag(index, text) {
    // Create a new tag for the selected option
    const tag = document.createElement('span');
    tag.className = 'select-multiple__selected-tags__tag';
    tag.dataset.index = index;
    tag.innerHTML = text + '<i class="select-multiple__selected-tags__tag__remove"></i>';
    selectedTags.appendChild(tag);

    // Update the option state in the original select
    const option = originalSelect.options[index];
    if (option) option.selected = true;
    updatePlaceholder();
    updateHiddenInputs();
  }
  function removeTag(tag) {
    const index = tag.dataset.index;
    tag.remove();

    // Deselect the option in the original select
    const option = originalSelect.options[index];
    if (option) option.selected = false;

    // Update state in the dropdown list
    const item = dropdown.querySelector(`li[data-index="${index}"]`);
    if (item) item.classList.remove('selected');
    updatePlaceholder();
    updateHiddenInputs();
  }
  function updatePlaceholder() {
    // Show or hide placeholder depending on whether there are selected tags
    if (selectedTags.children.length > 0) {
      placeholder.style.display = 'none';
    } else {
      placeholder.style.display = 'block';
    }
  }
  function updateHiddenInputs() {
    // Update hidden fields with selected values
    const selectedValues = Array.from(originalSelect.selectedOptions).map(option => option.value);
    const selectedText = selectedValues.join(', ');
    const hiddenInputs = document.querySelectorAll('.food-restrictions-property');
    hiddenInputs.forEach(input => {
      input.value = selectedText;
    });
  }
  function toggleDropdown() {
    container.classList.toggle('open');
  }
  function closeDropdown() {
    container.classList.remove('open');
  }
  selectionArea.addEventListener('click', function (e) {
    if (e.target.closest('.select-multiple__selected-tags__tag__remove')) {
      removeTag(e.target.closest('.select-multiple__selected-tags__tag'));
    } else if (!e.target.closest('.select-multiple__selected-tags__tag')) {
      toggleDropdown();
    }
  });
  dropdown.addEventListener('click', function (e) {
    const item = e.target.closest('li');
    if (!item) return;
    const index = item.dataset.index;
    const text = item.textContent;

    // Toggle selection state of the clicked item
    if (item.classList.contains('selected')) {
      item.classList.remove('selected');
      const tag = selectedTags.querySelector(`[data-index="${index}"]`);
      if (tag) removeTag(tag);
    } else {
      item.classList.add('selected');
      addTag(index, text);
    }
  });

  // Close dropdown if clicking outside
  document.addEventListener('click', function (e) {
    if (!container.contains(e.target)) {
      closeDropdown();
    }
  });
  initOptions();
});